import React from "react";
import { Button } from "@ui/button";

export interface PagerProps {
  page: number;
  pageSize: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
}

export function Pager({ page, pageSize, total, onPrev, onNext }: PagerProps) {
  const maxPage = Math.max(0, Math.ceil(total / pageSize) - 1);
  return (
    <div className="flex items-center justify-center gap-4 mt-3">
      <Button size="sm" variant="outline" disabled={page === 0} onClick={onPrev}>
        Prev
      </Button>
      <span className="text-sm">
        Page {page + 1} / {maxPage + 1}
      </span>
      <Button
        size="sm"
        variant="outline"
        disabled={page >= maxPage}
        onClick={onNext}
      >
        Next
      </Button>
    </div>
  );
}
